let paramId = 1;
/** @internal */ function getParamName() {
    return `u_Param${paramId++}`;
}

export { getParamName };
//# sourceMappingURL=common.js.map
